export default "__VITE_ASSET__DiOaZ3Lo__"